module.exports = __webpack_public_path__ + "static/media/readMe.1629d4fe.txt";